import { createIcon } from '@chakra-ui/icons';

export const Schedule = createIcon({
  displayName: 'Schedule',
  viewBox: '0 0 48 49',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
      <g id="Lan-Schedule--Streamline-Ux.svg">
        <path
          id="Vector"
          d="M4.92871 24.5032C4.92871 29.4812 6.90624 34.2554 10.4263 37.7754C13.9463 41.2954 18.7204 43.273 23.6985 43.273C28.6765 43.273 33.4507 41.2954 36.9707 37.7754C40.4907 34.2554 42.4683 29.4812 42.4683 24.5032C42.4683 22.0383 41.9828 19.5975 41.0395 17.3203C40.0962 15.043 38.7137 12.9739 36.9707 11.2309C35.2278 9.488 33.1586 8.10543 30.8814 7.16216C28.6041 6.21889 26.1634 5.7334 23.6985 5.7334C21.2336 5.7334 18.7929 6.21889 16.5156 7.16216C14.2384 8.10543 12.1692 9.488 10.4263 11.2309C8.68332 12.9739 7.30075 15.043 6.35748 17.3203C5.41421 19.5975 4.92871 22.0383 4.92871 24.5032Z"
          fill="#FDE9C8"
        />
        <path
          id="Vector_2"
          d="M12.9609 35.4176C12.9609 35.6117 13.2413 35.8039 13.786 35.9832C14.3308 36.1626 15.1292 36.3255 16.1358 36.4628C17.1423 36.6 18.3373 36.7089 19.6524 36.7832C20.9675 36.8575 22.377 36.8957 23.8005 36.8957C25.224 36.8957 26.6335 36.8575 27.9486 36.7832C29.2637 36.7089 30.4587 36.6 31.4652 36.4628C32.4718 36.3255 33.2702 36.1626 33.8149 35.9832C34.3597 35.8039 34.64 35.6117 34.64 35.4176C34.64 35.2235 34.3597 35.0313 33.8149 34.8519C33.2702 34.6726 32.4718 34.5096 31.4652 34.3724C30.4587 34.2351 29.2637 34.1263 27.9486 34.052C26.6335 33.9777 25.224 33.9395 23.8005 33.9395C22.377 33.9395 20.9675 33.9777 19.6524 34.052C18.3373 34.1263 17.1423 34.2351 16.1358 34.3724C15.1292 34.5096 14.3308 34.6726 13.786 34.8519C13.2413 35.0313 12.9609 35.2235 12.9609 35.4176Z"
          fill="#F1CA89"
        />
        <g id="Group 362">
          <path id="Vector_3" d="M22.8271 13.96H24.8452V17.9961H22.8271V13.96Z" fill="white" />
          <path
            id="Vector_4"
            d="M26.862 12.9502C26.862 13.0827 26.836 13.2139 26.7853 13.3364C26.7347 13.4588 26.6604 13.5701 26.5667 13.6638C26.473 13.7576 26.3618 13.8319 26.2394 13.8826C26.1169 13.9334 25.9857 13.9595 25.8532 13.9595H21.817C21.5534 13.9534 21.3027 13.8444 21.1185 13.6558C20.9342 13.4673 20.8311 13.2141 20.8311 12.9504C20.8311 12.6868 20.9342 12.4336 21.1185 12.2451C21.3027 12.0565 21.5534 11.9475 21.817 11.9414H25.8532C26.1207 11.9414 26.3773 12.0477 26.5665 12.2369C26.7557 12.426 26.862 12.6826 26.862 12.9502Z"
            fill="#F6D59D"
          />
          <path
            id="Vector_5"
            d="M26.862 12.9502C26.862 13.0827 26.836 13.2139 26.7853 13.3364C26.7347 13.4588 26.6604 13.5701 26.5667 13.6638C26.473 13.7576 26.3618 13.8319 26.2394 13.8826C26.1169 13.9334 25.9857 13.9595 25.8532 13.9595H21.817C21.5534 13.9534 21.3027 13.8444 21.1185 13.6558C20.9342 13.4673 20.8311 13.2141 20.8311 12.9504C20.8311 12.6868 20.9342 12.4336 21.1185 12.2451C21.3027 12.0565 21.5534 11.9475 21.817 11.9414H25.8532C26.1207 11.9414 26.3773 12.0477 26.5665 12.2369C26.7557 12.426 26.862 12.6826 26.862 12.9502Z"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_6"
            d="M22.8271 13.96H24.8452V17.9961H22.8271V13.96Z"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_7"
            d="M29.4569 14.9374C29.3631 15.031 29.2887 15.1422 29.238 15.2646C29.1873 15.387 29.1611 15.5182 29.1611 15.6507C29.1611 15.7832 29.1873 15.9145 29.238 16.0369C29.2887 16.1593 29.3631 16.2705 29.4569 16.3641L32.3104 19.2182C32.4037 19.3136 32.5151 19.3896 32.638 19.4417C32.7609 19.4938 32.8929 19.521 33.0264 19.5218C33.1599 19.5225 33.2922 19.4968 33.4157 19.446C33.5391 19.3953 33.6513 19.3206 33.7457 19.2262C33.8401 19.1318 33.9148 19.0196 33.9656 18.8961C34.0163 18.7727 34.0421 18.6403 34.0413 18.5068C34.0406 18.3734 34.0133 18.2413 33.9612 18.1184C33.9091 17.9955 33.8331 17.8842 33.7377 17.7909L30.8836 14.9374C30.79 14.8436 30.6788 14.7692 30.5564 14.7185C30.434 14.6677 30.3028 14.6416 30.1703 14.6416C30.0378 14.6416 29.9065 14.6677 29.7841 14.7185C29.6617 14.7692 29.5505 14.8436 29.4569 14.9374Z"
            fill="#F6D59D"
          />
          <path
            id="Vector_8"
            d="M29.4569 14.9374C29.3631 15.031 29.2887 15.1422 29.238 15.2646C29.1873 15.387 29.1611 15.5182 29.1611 15.6507C29.1611 15.7832 29.1873 15.9145 29.238 16.0369C29.2887 16.1593 29.3631 16.2705 29.4569 16.3641L32.3104 19.2182C32.4037 19.3136 32.5151 19.3896 32.638 19.4417C32.7609 19.4938 32.8929 19.521 33.0264 19.5218C33.1599 19.5225 33.2922 19.4968 33.4157 19.446C33.5391 19.3953 33.6513 19.3206 33.7457 19.2262C33.8401 19.1318 33.9148 19.0196 33.9656 18.8961C34.0163 18.7727 34.0421 18.6403 34.0413 18.5068C34.0406 18.3734 34.0133 18.2413 33.9612 18.1184C33.9091 17.9955 33.8331 17.8842 33.7377 17.7909L30.8836 14.9374C30.79 14.8436 30.6788 14.7692 30.5564 14.7185C30.434 14.6677 30.3028 14.6416 30.1703 14.6416C30.0378 14.6416 29.9065 14.6677 29.7841 14.7185C29.6617 14.7692 29.5505 14.8436 29.4569 14.9374Z"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_9"
            d="M29.2168 18.0284L30.168 17.0771L31.595 18.5041L30.6438 19.4554L29.2168 18.0284Z"
            fill="white"
          />
          <path
            id="Vector_10"
            d="M27.3164 19.9311L30.1704 17.0771L31.5974 18.5041L28.7434 21.3581L27.3164 19.9311Z"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_11"
            d="M18.426 14.9363C18.5198 15.0299 18.5942 15.1411 18.6449 15.2635C18.6957 15.3859 18.7218 15.5171 18.7218 15.6497C18.7218 15.7822 18.6957 15.9134 18.6449 16.0358C18.5942 16.1582 18.5198 16.2694 18.426 16.363L15.5747 19.2171C15.4814 19.3125 15.37 19.3885 15.2471 19.4406C15.1242 19.4927 14.9922 19.52 14.8587 19.5207C14.7252 19.5214 14.5929 19.4957 14.4694 19.445C14.3459 19.3942 14.2338 19.3195 14.1394 19.2251C14.045 19.1307 13.9702 19.0185 13.9195 18.895C13.8688 18.7716 13.843 18.6393 13.8438 18.5058C13.8445 18.3723 13.8717 18.2403 13.9238 18.1174C13.976 17.9945 14.0519 17.8831 14.1474 17.7898L17.0014 14.9363C17.1905 14.7476 17.4466 14.6416 17.7137 14.6416C17.9808 14.6416 18.237 14.7476 18.426 14.9363Z"
            fill="#F6D59D"
          />
          <path
            id="Vector_12"
            d="M18.426 14.9363C18.5198 15.0299 18.5942 15.1411 18.6449 15.2635C18.6957 15.3859 18.7218 15.5171 18.7218 15.6497C18.7218 15.7822 18.6957 15.9134 18.6449 16.0358C18.5942 16.1582 18.5198 16.2694 18.426 16.363L15.5747 19.2171C15.4814 19.3125 15.37 19.3885 15.2471 19.4406C15.1242 19.4927 14.9922 19.52 14.8587 19.5207C14.7252 19.5214 14.5929 19.4957 14.4694 19.445C14.3459 19.3942 14.2338 19.3195 14.1394 19.2251C14.045 19.1307 13.9702 19.0185 13.9195 18.895C13.8688 18.7716 13.843 18.6393 13.8438 18.5058C13.8445 18.3723 13.8717 18.2403 13.9238 18.1174C13.976 17.9945 14.0519 17.8831 14.1474 17.7898L17.0014 14.9363C17.1905 14.7476 17.4466 14.6416 17.7137 14.6416C17.9808 14.6416 18.237 14.7476 18.426 14.9363Z"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_13"
            d="M16.2881 18.5041L17.7151 17.0771L20.5691 19.9311L19.1421 21.3581L16.2881 18.5041Z"
            fill="white"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_14"
            d="M22.3524 34.6901C24.7764 35.0834 27.2574 34.4977 29.2496 33.0618C31.2418 31.6259 32.5819 29.4574 32.9753 27.0334C33.3686 24.6094 32.7829 22.1284 31.347 20.1363C29.9111 18.1441 27.7426 16.8039 25.3186 16.4106C24.1184 16.2158 22.8915 16.2594 21.7081 16.5387C20.5246 16.8181 19.4078 17.3278 18.4214 18.0388C17.435 18.7498 16.5983 19.6481 15.959 20.6825C15.3197 21.7168 14.8905 22.867 14.6957 24.0672C14.501 25.2675 14.5445 26.4943 14.8239 27.6778C15.1033 28.8612 15.613 29.978 16.324 30.9644C17.035 31.9508 17.9333 32.7876 18.9677 33.4268C20.002 34.0661 21.1521 34.4953 22.3524 34.6901Z"
            fill="#F6D59D"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_15"
            d="M22.7446 32.2858C24.5307 32.5757 26.3588 32.1441 27.8267 31.0861C29.2947 30.028 30.2822 28.4302 30.572 26.644C30.8618 24.8579 30.4303 23.0298 29.3722 21.5619C28.3142 20.0939 26.7163 19.1064 24.9302 18.8166C24.0458 18.6731 23.1418 18.7052 22.2698 18.911C21.3978 19.1169 20.5749 19.4925 19.848 20.0164C19.1212 20.5403 18.5046 21.2022 18.0336 21.9644C17.5626 22.7265 17.2462 23.574 17.1027 24.4584C16.9592 25.3428 16.9913 26.2468 17.1972 27.1188C17.403 27.9908 17.7786 28.8137 18.3025 29.5406C18.8264 30.2674 19.4883 30.884 20.2505 31.355C21.0127 31.826 21.8601 32.1423 22.7446 32.2858Z"
            fill="white"
          />
          <path
            id="Vector_16"
            d="M23.8369 22.627L23.8553 25.5328H25.2183"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_17"
            d="M23.8369 30.7714V29.9014"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_18"
            d="M23.8369 20.334V21.204"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_19"
            d="M27.5277 21.8623L26.9121 22.4774"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_20"
            d="M29.056 25.5518H28.1865"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_21"
            d="M27.5277 29.2411L26.9121 28.626"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_22"
            d="M20.1455 29.2411L20.7606 28.626"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_23"
            d="M18.6172 25.5518H19.4872"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_24"
            d="M20.1455 21.8623L20.7606 22.4774"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_25"
            d="M22.7446 32.2858C24.5307 32.5757 26.3588 32.1441 27.8267 31.0861C29.2947 30.028 30.2822 28.4302 30.572 26.644C30.8618 24.8579 30.4303 23.0298 29.3722 21.5619C28.3142 20.0939 26.7163 19.1064 24.9302 18.8166C24.0458 18.6731 23.1418 18.7052 22.2698 18.911C21.3978 19.1169 20.5749 19.4925 19.848 20.0164C19.1212 20.5403 18.5046 21.2022 18.0336 21.9644C17.5626 22.7265 17.2462 23.574 17.1027 24.4584C16.9592 25.3428 16.9913 26.2468 17.1972 27.1188C17.403 27.9908 17.7786 28.8137 18.3025 29.5406C18.8264 30.2674 19.4883 30.884 20.2505 31.355C21.0127 31.826 21.8601 32.1423 22.7446 32.2858Z"
            stroke="#453924"
            strokeWidth="0.545483"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>,
  ],
});
